var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172.431399999999485 132.083299999998417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;stroke-width:3.5px;}.cls-1,.cls-2,.cls-4,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#fff;}.cls-2{stroke-dasharray:0 0 4.811446189880371 4.811446189880371;}.cls-3{stroke-width:0px;}.cls-4{stroke-dasharray:0 0 5.904006004333496 5.904006004333496;}.cls-5{stroke:#e8ba3a;}.cls-6{stroke-dasharray:0 0 5.904115676879883 5.904115676879883;}.cls-10{clip-path:url(#clippath);}.cls-7{stroke-dasharray:0 0 6.204822063446045 6.204822063446045;}.cls-8{stroke-dasharray:0 0 6.649785041809082 6.649785041809082;}.cls-9{stroke-dasharray:0 0 3.532835721969604 3.532835721969604;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.91436219e-7,
    y: -0.000003893655958,
    width: 172.43139881712523,
    height: 132.08330778731033
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.653779119327737,129.763462715480273s2.258097088018985-8.016244662463578,12.193724275299246-7.790434953662043c0,0,5.758147574446411-12.475986411302074,19.476087384156926-7.508172817662853,0,0,6.943648545659016-6.604933982453076,14.90344078092312-4.233932040035143,7.959792235264104,2.371001942419753,9.653365051279252,7.395267963260267,9.653365051279252,7.395267963260267,0,0,14.73408349931924-2.596811651219468,16.201846606531035,12.137271848099772H47.653779119327737Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.416631654807134,76.71363948430735s13.345070752877291,6.378725732665771,20.500068871429903,34.231609563543316c0,0-2.487084406535359-23.232048195763127,20.255084466947665-48.07564240845204"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2369",
    className: "cls-1",
    d: "m117.560826160699435,50.189202184777969c-.538542507456441-1.423473036815267-1.837885521748831-2.415330125555556-3.352981734162313-2.559507893500268-7.398284464092285-.703620149111885-14.548069222910271,1.889977977196395-18.936822111330912,7.639289517906946-4.388273548991492,5.748683601113953-5.005485799663802,13.329932889395423-2.376150344587586,20.280924179007343.53902046098483,1.422846757926891,1.838363549948554,2.414703903668851,3.352981734160494,2.55950789349663,7.398910611294923.704098120306298,14.548547650183536-1.89060472185156,18.93682211133455-7.639289517905127,4.388752888422459-5.749311540710551,5.006112544340795-13.329454462120339,2.376150344585767-20.280924179005524Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2367-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2369-2",
    className: "cls-1",
    d: "m55.801568154800407,66.001452471238736c.454951423278544-1.202525474087452,1.552613994930653-2.040429238344586,2.83254114774536-2.162228130397125,6.249943133821944-.594406168227579,12.289958001936611,1.596620802967664,15.997500759203831,6.453540047215938,3.707137819581476,4.856388771706406,4.228548085287912,11.26089743382181,2.007330835029279,17.13297500729459-.455355190177215,1.201996404484817-1.553017824908238,2.039900216894239-2.83254114774536,2.162228130395306-6.250472092180644.594809950049239-12.290362169047512-1.59715026604681-15.99750075920565-6.453540047215938-3.707542757265401-4.856919244246455-4.22907754838343-11.26049326671091-2.00733083502746-17.132975007292771Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.252196733177698,110.776838835685339c-.2724609375.96484375-.56396484375,1.921630859375-.873046875,2.870361328125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m157.204345170677698,116.979109343497839c-.62890625,1.6588134765625-1.31494140625,3.2896728515625-2.0556640625,4.89013671875"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.390868608177698,123.458967741935339c-.44189453125.898681640625-.90087890625,1.7872314453125-1.376953125,2.665283203125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.709227983177698,45.960432585685339c.58740234375.807861328125,1.1591796875,1.6278076171875,1.71484375,2.45947265625"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m152.507079545677698,53.450422820060339c5.1826171875,9.250732421875,8.4716796875,19.7056884765625,9.341796875,30.8399658203125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m162.022216264427698,87.247419890372839c.0390625.9952392578125.05859375,1.995361328125.05859375,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m97.255614701927698,15.587141570060339c.99365234375.139404296875,1.9814453125.2982177734375,2.96240234375.47607421875"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m106.702880326927698,17.538191374747839c7.591796875,2.0853271484375,14.7041015625,5.327880859375,21.13671875,9.5260009765625"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.583739701927698,28.942732390372839c.81298828125.5831298828125,1.61376953125,1.1820068359375,2.40185546875,1.796142578125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.285888139427698,30.047834929435339c.79736328125-.602294921875,1.60693359375-1.1890869140625,2.4287109375-1.7598876953125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m48.949950639427698,24.960432585685339c6.19580078125-3.5888671875,12.94970703125-6.321044921875,20.099609375-8.0345458984375"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.081298295677698,16.265486296622839c.97802734375-.1920166015625,1.96337890625-.365234375,2.955078125-.5189208984375"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.289794389427698,90.247419890372839c0-1.004638671875.01953125-2.0047607421875.05859375-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m11.808349076927698,81.359602507560339c1.298828125-11.0604248046875,4.99169921875-21.3885498046875,10.54638671875-30.4525146484375"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.947020951927698,48.419294890372839c.5556640625-.8316650390625,1.12744140625-1.651611328125,1.71484375-2.45947265625"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.462645951927698,129.763411101310339c-.5244140625-.850341796875-1.0322265625-1.7119140625-1.5234375-2.584228515625"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.714599076927698,122.913313445060339c-1.0400390625-2.1602783203125-1.98046875-4.377685546875-2.814453125-6.6463623046875"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.106200639427698,113.996321257560339c-.31396484375-.9471435546875-.60986328125-1.902587890625-.88671875-2.865966796875"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 159.79246095950657,
    cy: 99.80874174581777,
    r: 8.624617003954654
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 142.54322695159772,
    cy: 37.33836287606755,
    r: 8.624617003956244
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 86.21570000000065,
    cy: 15.590929846744984,
    r: 8.624617003954882
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 29.850664658392816,
    cy: 36.71943188100977,
    r: 8.62461700395579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12.601430650483962,
    cy: 99.80874174581777,
    r: 8.624617003954654
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "83.868011168422527 14.5298563067754 86.079460263710644 18.079308462472909 94.796406640210989 8.216730926922537"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "27.382922722910735 39.595278800599772 27.382922722910735 34.079149768342177 32.318406593878535 39.595278800599772 32.318406593878535 33.843584961419765"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m140.944758245237608,40.886749972840335v-7.096774193549209h2.709677419354193c1.015491314205065,0,1.838709677418592.823218363213527,1.838709677418592,1.838709677420411v.103221472636505c0,1.00024916343682-.799574209821003,1.817016551045526-1.799597046936469,1.838293632685236l-2.748790049836316.058484894678259"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.48173212388247,
    y1: 96.39745142323773,
    x2: 157.48173212388247,
    y2: 103.22003206839872
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "162.103189795132494 96.574528500314045 158.56237728517408 99.808741745819134 161.981732123882466 103.220032068398723"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.64778702017793,96.048383203118647h-2.086955946582748c-.974374975177852,0-1.764261959933719.789886984754048-1.764261959933719,1.7642619599319v.201013147870981c0,.974374975177852.789886984755867,1.7642619599319,1.764261959933719,1.7642619599319h.58191057651311c.974374975177852,0,1.7642619599319.789886984754048,1.7642619599319,1.7642619599319v.000003528528396c0,.974374975177852-.789886984752229,1.7642619599319-1.7642619599319,1.7642619599319h-2.716481950534217"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.f662f9e1574a5b18bc3f1ca8a802db7b.svg";
export { ForwardRef as ReactComponent };